export function getAll() {
  return [
    {
      value: 0,
      name: "Minute",
      text: `分鐘`,
    },
    {
      value: 1,
      name: "Hour",
      text: `小時`,
    },
    {
      value: 2,
      name: "Day",
      text: `天`,
    },
  ];
}
